import {
  TRANSACTION_BARGRAPH_FETCH_REQUEST,
  TRANSACTION_BARGRAPH_DROPDOWN_REQUEST,
  TRANSACTION_BARGRAPH_FETCH_REQUEST_SUCCESS,
  TRANSACTION_BARGRAPH_DROPDOWN_REQUEST_SUCCESS,
  TRANSACTION_BARGRAPH_FETCH_REQUEST_FAILURE,
  TRANSACTION_BARGRAPH_DROPDOWN_REQUEST_FAILURE,
  TRANSACTION_BARGRAPH_CURRENCY_DROPDOWN_REQUEST,
  TRANSACTION_BARGRAPH_CURRENCY_DROPDOWN_REQUEST_SUCCESS,
  TRANSACTION_BARGRAPH_CURRENCY_DROPDOWN_REQUEST_FAILURE,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};
const DROPDOWN_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};
const DROPDOWN_CURRENCY_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};
export const transactionBarGraphReducer = (state, action) => {
  state = state || INITIAL_STATE;
  switch (action.type) {
    case TRANSACTION_BARGRAPH_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });
    case TRANSACTION_BARGRAPH_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });
    case TRANSACTION_BARGRAPH_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });
    default:
      return state;
  }
};

export const transactionBarGraphDropDownReducer = (state, action) => {
  state = state || DROPDOWN_INITIAL_STATE;
  switch (action.type) {
    case TRANSACTION_BARGRAPH_DROPDOWN_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });
    case TRANSACTION_BARGRAPH_DROPDOWN_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
      });
    case TRANSACTION_BARGRAPH_DROPDOWN_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });
    default:
      return state;
  }
};

export const transactionBarGraphCurrencyDropDownReducer = (state, action) => {
  state = state || DROPDOWN_CURRENCY_INITIAL_STATE;
  switch (action.type) {
    case TRANSACTION_BARGRAPH_CURRENCY_DROPDOWN_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });
    case TRANSACTION_BARGRAPH_CURRENCY_DROPDOWN_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
      });
    case TRANSACTION_BARGRAPH_CURRENCY_DROPDOWN_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });
    default:
      return state;
  }
};
